module.exports = __webpack_public_path__ + "img/cloud-blank-01.22aae259.svg";